// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Lang_eval$BwaxAdmin = require("../../lang_eval.bs.js");
var Caml_chrome_debugger = require("bs-platform/lib/js/caml_chrome_debugger.js");
var Lang_value_set$BwaxAdmin = require("../../lang_value_set.bs.js");
var Runtime_common$BwaxAdmin = require("../runtime_common.bs.js");

var module_name = "Set";

var src = "\nmodule " + (String(module_name) + ";\n\n-- Create an empty set.\nempty: () -> Set t = external;\n\n-- Create a set with one value.\nsingleton : comparable -> Set comparable = external;\n\n-- Insert a value into a set.\ninsert: comparable -> Set comparable -> Set comparable = external;\n\n-- Remove a value from a set. If the value is not found, no changes are made.\nremove : comparable -> Set comparable -> Set comparable = external;\n\n-- Remove a list of value from a set.\nremoveMany: List comparable -> Set comparable -> Set comparable = external;\n\n-- Determine if a set is empty.\nisEmpty : Set a -> Bool = external;\n\n-- Determine if a value is in a set.\nmember : comparable -> Set comparable -> Bool = external;\n\nhas = member;\n\n-- Determine the number of elements in a set.\nsize : Set a -> Int = external;\n\n\n-- Get the union of two sets. Keep all values.\nunion : Set comparable -> Set comparable -> Set comparable = external;\n\n-- Get the intersection of two sets. Keeps values that appear in both sets.\nintersect : Set comparable -> Set comparable -> Set comparable = external;\n\n-- Get the difference between the first set and the second. \n-- Keeps values that do not appear in the second set.\ndiff : Set comparable -> Set comparable -> Set comparable = external;\n\n\n\n-- Convert a set into a list, sorted from lowest to highest.\ntoList : Set a -> List a = external;\n\n-- Convert a list into a set, removing any duplicates.\nfromList : List comparable -> Set comparable = external;\n\n\n-- Fold over the values in a set, in order from lowest to highest.\nfoldl : (acc -> t -> acc) -> acc -> Set t -> a = external;\n\n-- Map a function onto a set, creating a new set with no duplicates.\nmap:  (comparable -> comparable2) -> Set comparable -> Set comparable2 = external;\n\n\n-- Only keep elements that pass the given test.\nfilter : (comparable -> Bool) -> Set comparable -> Set comparable = external;\n\n\n-- Create two new sets. \n-- The first contains all the elements that passed the given test, \n-- and the second contains all the elements that did not.\npartition :\n    (comparable -> Bool)\n    -> Set comparable\n    -> ( Set comparable, Set comparable ) = external;\n\n\n\n-- Check if some pair passes the given test\nany: (t ->  Bool) -> Set t -> Bool = external;\n\n-- Check if every pair passes the given test\nall: (t -> Bool) -> Set t -> Bool = external;\n\n\n-- Returns  the lowest key, or Nothing if not exists.\nminimum: Set t -> Maybe t = external;\n\n-- Return the highest key, or Nothing if not exists.\nmaximum: Set t -> Maybe t = external;\n\n-- Check if two sets are equal;\nisEqual: Set t -> Set t -> Bool = external;\n\n\n");

function invalid_args(name) {
  throw [
        Lang_eval$BwaxAdmin.Eval_exn,
        module_name + ("." + (name + ": Invalid Arguments"))
      ];
}

function pack_set(set) {
  return /* tuple */[
          /* V_tagged_raw */Caml_chrome_debugger.variant("V_tagged_raw", 8, [
              "Set",
              set
            ]),
          Runtime_common$BwaxAdmin.nt
        ];
}

function pack_predicate(f) {
  return (function (k) {
      var result = Lang_eval$BwaxAdmin.apply_value_args(module_name, f, /* :: */Caml_chrome_debugger.simpleVariant("::", [
              k,
              /* [] */0
            ]), Runtime_common$BwaxAdmin.nt);
      var match = result[0];
      if (typeof match === "number" || match.tag !== /* V_literal */5) {
        return invalid_args("predicate");
      } else {
        var match$1 = match[0];
        if (typeof match$1 === "number" || match$1.tag !== /* Bool */4) {
          return invalid_args("predicate");
        } else {
          return match$1[0];
        }
      }
    });
}

var external_vals_000 = /* tuple */[
  "empty",
  Runtime_common$BwaxAdmin.pack_func(1, (function (param) {
          return pack_set(Lang_value_set$BwaxAdmin.empty(/* () */0));
        }))
];

var external_vals_001 = /* :: */Caml_chrome_debugger.simpleVariant("::", [
    /* tuple */[
      "singleton",
      Runtime_common$BwaxAdmin.pack_func(1, (function (param) {
              if (param && !param[1]) {
                return pack_set(Lang_value_set$BwaxAdmin.singleton(param[0]));
              } else {
                return invalid_args("singleton");
              }
            }))
    ],
    /* :: */Caml_chrome_debugger.simpleVariant("::", [
        /* tuple */[
          "insert",
          Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                  if (param) {
                    var match = param[1];
                    if (match) {
                      var match$1 = match[0][0];
                      if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                        return invalid_args("insert");
                      } else {
                        return pack_set(Lang_value_set$BwaxAdmin.insert(param[0], match$1[1]));
                      }
                    } else {
                      return invalid_args("insert");
                    }
                  } else {
                    return invalid_args("insert");
                  }
                }))
        ],
        /* :: */Caml_chrome_debugger.simpleVariant("::", [
            /* tuple */[
              "remove",
              Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                      if (param) {
                        var match = param[1];
                        if (match) {
                          var match$1 = match[0][0];
                          if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                            return invalid_args("remove");
                          } else {
                            return pack_set(Lang_value_set$BwaxAdmin.remove(param[0], match$1[1]));
                          }
                        } else {
                          return invalid_args("remove");
                        }
                      } else {
                        return invalid_args("remove");
                      }
                    }))
            ],
            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                /* tuple */[
                  "removeMany",
                  Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                          if (param) {
                            var match = param[0][0];
                            if (typeof match === "number" || match.tag !== /* V_list */1) {
                              return invalid_args("removeMany");
                            } else {
                              var match$1 = param[1];
                              if (match$1) {
                                var match$2 = match$1[0][0];
                                if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_raw */8 && !match$1[1])) {
                                  return invalid_args("removeMany");
                                } else {
                                  return pack_set(Lang_value_set$BwaxAdmin.remove_many(match[0], match$2[1]));
                                }
                              } else {
                                return invalid_args("removeMany");
                              }
                            }
                          } else {
                            return invalid_args("removeMany");
                          }
                        }))
                ],
                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                    /* tuple */[
                      "isEmpty",
                      Runtime_common$BwaxAdmin.pack_func(1, (function (param) {
                              if (param) {
                                var match = param[0][0];
                                if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                  return invalid_args("isEmpty");
                                } else {
                                  return Runtime_common$BwaxAdmin.pack_bool(Lang_value_set$BwaxAdmin.is_empty(match[1]));
                                }
                              } else {
                                return invalid_args("isEmpty");
                              }
                            }))
                    ],
                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                        /* tuple */[
                          "member",
                          Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                                  if (param) {
                                    var match = param[1];
                                    if (match) {
                                      var match$1 = match[0][0];
                                      if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                                        return invalid_args("member");
                                      } else {
                                        return Runtime_common$BwaxAdmin.pack_bool(Lang_value_set$BwaxAdmin.member(param[0], match$1[1]));
                                      }
                                    } else {
                                      return invalid_args("member");
                                    }
                                  } else {
                                    return invalid_args("member");
                                  }
                                }))
                        ],
                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                            /* tuple */[
                              "size",
                              Runtime_common$BwaxAdmin.pack_func(1, (function (param) {
                                      if (param) {
                                        var match = param[0][0];
                                        if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                          return invalid_args("size");
                                        } else {
                                          return Runtime_common$BwaxAdmin.pack_int(Lang_value_set$BwaxAdmin.size(match[1]));
                                        }
                                      } else {
                                        return invalid_args("size");
                                      }
                                    }))
                            ],
                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                /* tuple */[
                                  "union",
                                  Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                                          if (param) {
                                            var match = param[0][0];
                                            if (typeof match === "number" || match.tag !== /* V_tagged_raw */8) {
                                              return invalid_args("union");
                                            } else {
                                              var match$1 = param[1];
                                              if (match$1) {
                                                var match$2 = match$1[0][0];
                                                if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_raw */8 && !match$1[1])) {
                                                  return invalid_args("union");
                                                } else {
                                                  return pack_set(Lang_value_set$BwaxAdmin.union(match[1], match$2[1]));
                                                }
                                              } else {
                                                return invalid_args("union");
                                              }
                                            }
                                          } else {
                                            return invalid_args("union");
                                          }
                                        }))
                                ],
                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                    /* tuple */[
                                      "intersect",
                                      Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                                              if (param) {
                                                var match = param[0][0];
                                                if (typeof match === "number" || match.tag !== /* V_tagged_raw */8) {
                                                  return invalid_args("intersect");
                                                } else {
                                                  var match$1 = param[1];
                                                  if (match$1) {
                                                    var match$2 = match$1[0][0];
                                                    if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_raw */8 && !match$1[1])) {
                                                      return invalid_args("intersect");
                                                    } else {
                                                      return pack_set(Lang_value_set$BwaxAdmin.intersect(match[1], match$2[1]));
                                                    }
                                                  } else {
                                                    return invalid_args("intersect");
                                                  }
                                                }
                                              } else {
                                                return invalid_args("intersect");
                                              }
                                            }))
                                    ],
                                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                        /* tuple */[
                                          "diff",
                                          Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                                                  if (param) {
                                                    var match = param[0][0];
                                                    if (typeof match === "number" || match.tag !== /* V_tagged_raw */8) {
                                                      return invalid_args("diff");
                                                    } else {
                                                      var match$1 = param[1];
                                                      if (match$1) {
                                                        var match$2 = match$1[0][0];
                                                        if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_raw */8 && !match$1[1])) {
                                                          return invalid_args("diff");
                                                        } else {
                                                          return pack_set(Lang_value_set$BwaxAdmin.diff(match[1], match$2[1]));
                                                        }
                                                      } else {
                                                        return invalid_args("diff");
                                                      }
                                                    }
                                                  } else {
                                                    return invalid_args("diff");
                                                  }
                                                }))
                                        ],
                                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                            /* tuple */[
                                              "toList",
                                              Runtime_common$BwaxAdmin.pack_func(1, (function (param) {
                                                      if (param) {
                                                        var match = param[0][0];
                                                        if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                                          return invalid_args("toList");
                                                        } else {
                                                          return Runtime_common$BwaxAdmin.pack_list(Lang_value_set$BwaxAdmin.to_list(match[1]));
                                                        }
                                                      } else {
                                                        return invalid_args("toList");
                                                      }
                                                    }))
                                            ],
                                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                /* tuple */[
                                                  "fromList",
                                                  Runtime_common$BwaxAdmin.pack_func(1, (function (param) {
                                                          if (param) {
                                                            var match = param[0][0];
                                                            if (typeof match === "number" || !(match.tag === /* V_list */1 && !param[1])) {
                                                              return invalid_args("fromList");
                                                            } else {
                                                              return pack_set(Lang_value_set$BwaxAdmin.from_list(match[0]));
                                                            }
                                                          } else {
                                                            return invalid_args("fromList");
                                                          }
                                                        }))
                                                ],
                                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                    /* tuple */[
                                                      "foldl",
                                                      Runtime_common$BwaxAdmin.pack_func(3, (function (param) {
                                                              if (param) {
                                                                var match = param[1];
                                                                if (match) {
                                                                  var match$1 = match[1];
                                                                  if (match$1) {
                                                                    var match$2 = match$1[0][0];
                                                                    if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_raw */8 && !match$1[1])) {
                                                                      return invalid_args("foldl");
                                                                    } else {
                                                                      var f = param[0];
                                                                      var proc = function (acc, k) {
                                                                        return Lang_eval$BwaxAdmin.apply_value_args(module_name, f, /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                      acc,
                                                                                      /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                          k,
                                                                                          /* [] */0
                                                                                        ])
                                                                                    ]), Runtime_common$BwaxAdmin.nt);
                                                                      };
                                                                      return Lang_value_set$BwaxAdmin.foldl(proc, match[0], match$2[1]);
                                                                    }
                                                                  } else {
                                                                    return invalid_args("foldl");
                                                                  }
                                                                } else {
                                                                  return invalid_args("foldl");
                                                                }
                                                              } else {
                                                                return invalid_args("foldl");
                                                              }
                                                            }))
                                                    ],
                                                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                        /* tuple */[
                                                          "map",
                                                          Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                                                                  if (param) {
                                                                    var match = param[1];
                                                                    if (match) {
                                                                      var match$1 = match[0][0];
                                                                      if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                                                                        return invalid_args("map");
                                                                      } else {
                                                                        var f = param[0];
                                                                        var proc = function (k) {
                                                                          return Lang_eval$BwaxAdmin.apply_value_args(module_name, f, /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                        k,
                                                                                        /* [] */0
                                                                                      ]), Runtime_common$BwaxAdmin.nt);
                                                                        };
                                                                        return pack_set(Lang_value_set$BwaxAdmin.map(proc, match$1[1]));
                                                                      }
                                                                    } else {
                                                                      return invalid_args("map");
                                                                    }
                                                                  } else {
                                                                    return invalid_args("map");
                                                                  }
                                                                }))
                                                        ],
                                                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                            /* tuple */[
                                                              "filter",
                                                              Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                                                                      if (param) {
                                                                        var match = param[1];
                                                                        if (match) {
                                                                          var match$1 = match[0][0];
                                                                          if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                                                                            return invalid_args("filter");
                                                                          } else {
                                                                            var p = pack_predicate(param[0]);
                                                                            return pack_set(Lang_value_set$BwaxAdmin.filter(p, match$1[1]));
                                                                          }
                                                                        } else {
                                                                          return invalid_args("filter");
                                                                        }
                                                                      } else {
                                                                        return invalid_args("filter");
                                                                      }
                                                                    }))
                                                            ],
                                                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                /* tuple */[
                                                                  "partition",
                                                                  Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                                                                          if (param) {
                                                                            var match = param[1];
                                                                            if (match) {
                                                                              var match$1 = match[0][0];
                                                                              if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                                                                                return invalid_args("partition");
                                                                              } else {
                                                                                var p = pack_predicate(param[0]);
                                                                                var match$2 = Lang_value_set$BwaxAdmin.partition(p, match$1[1]);
                                                                                return Runtime_common$BwaxAdmin.pack_tuple(/* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                              pack_set(match$2[0]),
                                                                                              /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                                  pack_set(match$2[1]),
                                                                                                  /* [] */0
                                                                                                ])
                                                                                            ]));
                                                                              }
                                                                            } else {
                                                                              return invalid_args("partition");
                                                                            }
                                                                          } else {
                                                                            return invalid_args("partition");
                                                                          }
                                                                        }))
                                                                ],
                                                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                    /* tuple */[
                                                                      "any",
                                                                      Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                                                                              if (param) {
                                                                                var match = param[1];
                                                                                if (match) {
                                                                                  var match$1 = match[0][0];
                                                                                  if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                                                                                    return invalid_args("any");
                                                                                  } else {
                                                                                    var predicate = pack_predicate(param[0]);
                                                                                    return Runtime_common$BwaxAdmin.pack_bool(Lang_value_set$BwaxAdmin.some(predicate, match$1[1]));
                                                                                  }
                                                                                } else {
                                                                                  return invalid_args("any");
                                                                                }
                                                                              } else {
                                                                                return invalid_args("any");
                                                                              }
                                                                            }))
                                                                    ],
                                                                    /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                        /* tuple */[
                                                                          "all",
                                                                          Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                                                                                  if (param) {
                                                                                    var match = param[1];
                                                                                    if (match) {
                                                                                      var match$1 = match[0][0];
                                                                                      if (typeof match$1 === "number" || !(match$1.tag === /* V_tagged_raw */8 && !match[1])) {
                                                                                        return invalid_args("all");
                                                                                      } else {
                                                                                        var p = pack_predicate(param[0]);
                                                                                        return Runtime_common$BwaxAdmin.pack_bool(Lang_value_set$BwaxAdmin.every(p, match$1[1]));
                                                                                      }
                                                                                    } else {
                                                                                      return invalid_args("all");
                                                                                    }
                                                                                  } else {
                                                                                    return invalid_args("all");
                                                                                  }
                                                                                }))
                                                                        ],
                                                                        /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                            /* tuple */[
                                                                              "minimum",
                                                                              Runtime_common$BwaxAdmin.pack_func(1, (function (param) {
                                                                                      if (param) {
                                                                                        var match = param[0][0];
                                                                                        if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                                                                          return invalid_args("minimum");
                                                                                        } else {
                                                                                          var result = Lang_value_set$BwaxAdmin.minimum(match[1]);
                                                                                          if (result !== undefined) {
                                                                                            return Runtime_common$BwaxAdmin.pack_just(result);
                                                                                          } else {
                                                                                            return Runtime_common$BwaxAdmin.pack_nothing;
                                                                                          }
                                                                                        }
                                                                                      } else {
                                                                                        return invalid_args("minimum");
                                                                                      }
                                                                                    }))
                                                                            ],
                                                                            /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                /* tuple */[
                                                                                  "maximum",
                                                                                  Runtime_common$BwaxAdmin.pack_func(1, (function (param) {
                                                                                          if (param) {
                                                                                            var match = param[0][0];
                                                                                            if (typeof match === "number" || !(match.tag === /* V_tagged_raw */8 && !param[1])) {
                                                                                              return invalid_args("maximum");
                                                                                            } else {
                                                                                              var result = Lang_value_set$BwaxAdmin.maximum(match[1]);
                                                                                              if (result !== undefined) {
                                                                                                return Runtime_common$BwaxAdmin.pack_just(result);
                                                                                              } else {
                                                                                                return Runtime_common$BwaxAdmin.pack_nothing;
                                                                                              }
                                                                                            }
                                                                                          } else {
                                                                                            return invalid_args("maximum");
                                                                                          }
                                                                                        }))
                                                                                ],
                                                                                /* :: */Caml_chrome_debugger.simpleVariant("::", [
                                                                                    /* tuple */[
                                                                                      "isEqual",
                                                                                      Runtime_common$BwaxAdmin.pack_func(2, (function (param) {
                                                                                              if (param) {
                                                                                                var match = param[0][0];
                                                                                                if (typeof match === "number" || match.tag !== /* V_tagged_raw */8) {
                                                                                                  return invalid_args("isEqual");
                                                                                                } else {
                                                                                                  var match$1 = param[1];
                                                                                                  if (match$1) {
                                                                                                    var match$2 = match$1[0][0];
                                                                                                    if (typeof match$2 === "number" || !(match$2.tag === /* V_tagged_raw */8 && !match$1[1])) {
                                                                                                      return invalid_args("isEqual");
                                                                                                    } else {
                                                                                                      return Runtime_common$BwaxAdmin.pack_bool(Lang_value_set$BwaxAdmin.is_equal(match[1], match$2[1]));
                                                                                                    }
                                                                                                  } else {
                                                                                                    return invalid_args("isEqual");
                                                                                                  }
                                                                                                }
                                                                                              } else {
                                                                                                return invalid_args("isEqual");
                                                                                              }
                                                                                            }))
                                                                                    ],
                                                                                    /* [] */0
                                                                                  ])
                                                                              ])
                                                                          ])
                                                                      ])
                                                                  ])
                                                              ])
                                                          ])
                                                      ])
                                                  ])
                                              ])
                                          ])
                                      ])
                                  ])
                              ])
                          ])
                      ])
                  ])
              ])
          ])
      ])
  ]);

var external_vals = /* :: */Caml_chrome_debugger.simpleVariant("::", [
    external_vals_000,
    external_vals_001
  ]);

var externals_000 = module_name;

var externals = /* tuple */[
  externals_000,
  external_vals
];

exports.module_name = module_name;
exports.src = src;
exports.invalid_args = invalid_args;
exports.pack_set = pack_set;
exports.pack_predicate = pack_predicate;
exports.external_vals = external_vals;
exports.externals = externals;
/* src Not a pure module */
